import { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Link } from 'react-router-dom';
import { unMask } from '../../../utils/masks';
import { API_URL } from '../../../services/api';
import { Container } from '../styles';
import { RedirectTo } from '../../../utils/redirectTo';
import { maskDocumentCpfCnpj } from '../../../utils/mask-document-cpf-cnpj';

export function ResendCodeForm() {
  const [loading, setLoading] = useState(false);
  const [cpfCnpj, setCpfCnpj] = useState('');

  const history = useHistory();

  const handleSubmit = async (e) => {
    e.preventDefault();

    setLoading(true);

    const body = { cpfCnpj: unMask(cpfCnpj) };

    const res = await fetch(`${API_URL}/resend-code`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(body),
    });

    const response = await res.json();

    if (!res.ok) {
      toast.error(response.message);
    } else {
      toast.success(response.message);
      setCpfCnpj('');
      setTimeout(() => history.push(RedirectTo.activate), 3000);
    }

    setLoading(false);
  };

  const onChangeCpfCnpj = (e) => {
    const formatted = maskDocumentCpfCnpj(e.target.value.toUpperCase());
    setCpfCnpj(formatted);
  };

  return (
    <Container>
      <h2>Reenviar código de ativação</h2>

      <form onSubmit={handleSubmit}>

        <input
          placeholder="Cpf ou Cnpj"
          guide={false}
          type="text"
          value={cpfCnpj}
          autoFocus
          onChange={onChangeCpfCnpj}
          required
        />

        <div className='is-flex is-justify-content-end is-align-items-center'>
          <Link to={RedirectTo.login}>
            <span>Acessar Conta</span>
          </Link>
        </div>

        {loading ? (
          <button disabled type="submit">
            Reenviar
          </button>
        ) : (
          <button type="submit">Reenviar</button>
        )}
      </form>
    </Container>
  );
}
